<div class="card">
    <div class="card-header">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="mb-0">{{ 'COMPANIES.TITLE' | translate }}</h4>
            <button class="btn btn-primary" (click)="openCampaignDialog()" [disabled]="pagination.itemsAmount === 0">
                <i class="ti ti-target me-2"></i>
                Nova Campanha
                @if (totalAvailableForCampaign > 0) {
                    <span class="badge bg-white text-primary ms-2">{{ totalAvailableForCampaign | number }}</span>
                }
            </button>
        </div>

        <app-filter-bar searchColClass="col" actionsColClass="col-auto">
            <app-input [(ngModel)]="filters.q"
                       (ngModelChange)="updateSearch()"
                       placeholder="{{ 'common.filter.field_search_records' | translate }}"
                       groupIconPosition="right"
                       groupIcon="ti-search"
                       slot="search"
                       containerStyles="mb-0"/>
            <!-- Filters -->
            <app-dropdown-filters
                    slot="filters"
                    [activeFiltersCount]="getActiveFiltersCount()"
                    (onApply)="updateSearch()"
                    (onClear)="resetFilters()">

                <!-- Filtros Gerais da Empresa -->
                <div class="filter-section-title">
                    <i class="ti ti-building me-2"></i>
                    <strong>Dados da Empresa</strong>
                </div>

                <app-select
                        [(ngModel)]="filters.state"
                        (ngModelChange)="onStateChange($event)"
                        [items]="(states$ | async) ?? []"
                        label="Estado"
                        bindLabel="nome"
                        bindValue="sigla"
                        placeholder="Estado"
                        [clearable]="true"/>
                <app-select
                        [(ngModel)]="filters.city"
                        [items]="(cities$ | async) ?? []"
                        label="Cidade"
                        bindLabel="nome"
                        bindValue="nome"
                        placeholder="Cidade"
                        [clearable]="true"
                        [disabled]="!filters.state"/>
                <app-select
                        [(ngModel)]="filters.companySize"
                        [items]="companySizeOptions"
                        bindLabel="name"
                        bindValue="value"
                        label="Porte da Empresa"
                        placeholder="Porte"
                        [multiple]="true"
                        [clearable]="true"/>
                <app-select
                        [(ngModel)]="filters.registrationStatus"
                        [items]="registrationStatusOptions"
                        bindLabel="name"
                        bindValue="value"
                        label="Situação Cadastral"
                        placeholder="Situação"
                        [clearable]="true"/>
                <app-select
                        [(ngModel)]="filters.personType"
                        [items]="personTypeOptions"
                        bindLabel="name"
                        bindValue="value"
                        label="Tipo de Pessoa"
                        placeholder="Tipo de Pessoa"
                        [clearable]="true"/>

                <!-- Divider -->
                <div class="filter-divider"></div>

                <!-- Filtros de Dívidas Específicas -->
                <div class="filter-section-title">
                    <i class="ti ti-file-invoice me-2"></i>
                    <strong>Filtros por Dívida Específica</strong>
                    <small class="d-block text-muted mt-1">Empresas com pelo menos 1 dívida que atenda aos critérios</small>
                </div>

                <app-switch
                        [(ngModel)]="filters.excludeRescindedTransacaoRepactuacaoUpTo26Overdues"
                        label="Excluir empresas com transação/repactuação rescindida"
                        description="Remove empresas que tenham ao menos uma dívida com transação/repactuação rescindida e até 26 parcelas em atraso"/>
                <app-currency [(ngModel)]="filters.minDebtInstallmentValue"
                              label="Valor do Parcelamento (mín)"
                              placeholder="Valor Parc. (mín)"/>
                <app-currency [(ngModel)]="filters.maxDebtInstallmentValue"
                              label="Valor do Parcelamento (máx)"
                              placeholder="Valor Parc. (máx)"/>
                <app-input [(ngModel)]="filters.minInstallmentRemaining"
                           type="number"
                           label="Parcelas Restantes (mín)"
                           placeholder="Parc. Rest. (mín)"/>
                <app-input [(ngModel)]="filters.maxInstallmentRemaining"
                           type="number"
                           label="Parcelas Restantes (máx)"
                           placeholder="Parc. Rest. (máx)"/>
                <app-datepicker
                        [(ngModel)]="filters.startMonthInstallment"
                        [monthYearOnly]="true"
                        label="Parcelas De (Mês/Ano)"
                        placeholder="De"/>
                <app-datepicker
                        [(ngModel)]="filters.endMonthInstallment"
                        [monthYearOnly]="true"
                        label="Parcelas Até (Mês/Ano)"
                        placeholder="Até"/>
                <app-select
                        [(ngModel)]="filters.negotiationType"
                        [items]="negotiationTypeOptions"
                        [closeOnSelect]="false"
                        bindLabel="name"
                        bindValue="value"
                        label="Tipo de Negociação"
                        placeholder="Tipo de Negociação"
                        [multiple]="true"
                        [clearable]="true"/>

                <!-- Divider -->
                <div class="filter-divider"></div>

                <!-- Filtros de Dados Consolidados -->
                <div class="filter-section-title">
                    <i class="ti ti-sum me-2"></i>
                    <strong>Dados Consolidados (Total)</strong>
                </div>
                <app-currency [(ngModel)]="filters.minEstimatedDebt"
                              label="Saldo Dev. Total (mín)"
                              placeholder="Saldo Dev. Total (mín)"/>
                <app-currency [(ngModel)]="filters.maxEstimatedDebt"
                              label="Saldo Dev. Total (máx)"
                              placeholder="Saldo Dev. Total (máx)"/>
                <app-input [(ngModel)]="filters.minTotalInstallmentRemaining"
                           type="number"
                           label="Parcelas Restantes Total (mín)"
                           placeholder="Parc. Rest. Total (mín)"/>
                <app-input [(ngModel)]="filters.maxTotalInstallmentRemaining"
                           type="number"
                           label="Parcelas Restantes Total (máx)"
                           placeholder="Parc. Rest. Total (máx)"/>
            </app-dropdown-filters>
        </app-filter-bar>
    </div>

    <div class="card-body p-0">
        <app-table [tableData]="items">
            <!-- Header da Tabela -->
            <ng-template app-table-header>
                <th scope="col" class="ps-4"
                    appTableHeaderColumn
                    labelKey="COMPANIES.TABLE.COMPANY"
                    sortField="name"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                </th>
                <th scope="col"
                    appTableHeaderColumn
                    labelKey="COMPANIES.TABLE.CITY"
                    sortField="city"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                </th>
                <th scope="col">{{ 'COMPANIES.TABLE.CONTACT' | translate }}</th>
                <th scope="col"
                    appTableHeaderColumn
                    labelKey="Parc. Restante"
                    sortField="totalInstallmentRemaining"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                </th>
                <th scope="col"
                    appTableHeaderColumn
                    labelKey="Saldo Devedor"
                    sortField="estimatedDebtValue"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)">
                </th>
                <th scope="col"  appTableHeaderColumn
                    labelKey="Campanha"
                    sortField="campaign"
                    [currentSort]="currentSort"
                    (sortChange)="onSort($event)"></th>
                <th scope="col" class="pe-4 text-end">{{ 'COMPANIES.TABLE.ACTIONS' | translate }}</th>
            </ng-template>

            <!-- Body da Tabela -->
            <ng-template app-table-body let-company>
                <td class="ps-4">
                    <div class="d-flex flex-column">
                        <strong class="cursor-pointer text-primary" (click)="viewDetails(company.id)">
                            {{ company.name }}
                        </strong>
                        <small class="text-muted">
                            <span class="cursor-pointer" (click)="copy(company.documentNumber)">
                                {{ company.documentNumber | cpfCnpj }}
                                <i class="ti ti-copy ti-ssm"></i>
                            </span>
                            @if (PersonTypeHelper.isPJ(company.personType)) {
                                <i class="ti ti-refresh ti-sm cursor-pointer ms-2"
                                   ngbTooltip="Atualizar Dados Empresa"
                                   (click)="enrichByDocumentNumber(company.documentNumber)"></i>
                            }
                            @if (company?.registrationStatus === 'Baixada') {
                                <span class="badge bg-danger badge-sm ms-2">Baixada</span>
                            }
                        </small>
                    </div>
                </td>
                <td>
                    <small>
                        <i class="ti ti-map-pin"></i>
                        @if (company.city) {
                            {{ company.city }}/
                        }
                        @if (company.state) {
                            {{ company.state }}
                        }
                    </small>
                </td>
                <td>
                    <div class="d-flex flex-column gap-1">
                        @if (company.email) {
                            <small>
                                <i class="ti ti-mail"></i>
                                <a [href]="'mailto:' + company.email" target="_blank" class="text-decoration-none">
                                    {{ company.email | lowercase }}
                                </a>
                            </small>
                        }
                        @if (company.phones && company.phones.length > 0) {
                            @if (company.phones && company.phones.length > 0) {
                                <small>
                                    <app-phone [areaCode]="company.phones[0].ddd" [phone]="company.phones[0].number" [isFax]="company.phones[0].isFax"/>
                                </small>
                            }
                        }
                        @if (!company.email && (!company.phones || company.phones.length === 0)) {
                            <small class="text-muted">—</small>
                        }
                    </div>
                </td>
                <td>
                    @if (company.totalInstallmentRemaining > 0) {
                        <span>
                          {{ company.totalInstallmentRemaining | number }}
                        </span>
                    } @else {
                        <span class="text-muted">—</span>
                    }
                </td>
                <td>
                    @if (company.estimatedDebtValue > 0) {
                        <span class="fw-bold">
                          {{ company.estimatedDebtValue | currency:'BRL' }}
                        </span>
                    } @else {
                        <span class="text-muted">—</span>
                    }
                </td>
                <td>
                    @if (company.campaignId && company.campaignName) {
                        <div class="campaign-info cursor-pointer" (click)="goToCampaign(company.campaignId)">
                            <div class="d-flex flex-column gap-1">
                                <small class="fw-semibold text-primary campaign-name">
                                    <i class="ti ti-speakerphone me-1"></i>
                                    {{ company.campaignName }}
                                </small>
                                @if (company.taskStatus) {
                                    <span class="badge badge-sm" [class]="'bg-' + getTaskStatusColor(company.taskStatus)">
                                        {{ getTaskStatusLabel(company.taskStatus) }}
                                    </span>
                                }
                            </div>
                        </div>
                    } @else {
                        <span class="text-muted">—</span>
                    }
                </td>
                <td class="pe-4 text-end">
                    <div class="btn-group btn-group-sm">
                        <button
                                class="btn btn-dark"
                                (click)="viewDebts(company.id)"
                                [title]="'COMPANIES.ACTIONS.VIEW_DEBTS' | translate">
                            <i class="ti ti-file-invoice"></i>
                        </button>
                        <button
                                class="btn btn-light"
                                (click)="viewDetails(company.id)"
                                [title]="'COMPANIES.ACTIONS.VIEW_DETAILS' | translate">
                            <i class="ti ti-eye"></i>
                        </button>
                    </div>
                </td>
            </ng-template>
        </app-table>

        <!-- Loading overlay -->
        <app-loading-overlay [show]="isLoading"/>

        <!-- Alert Empty Table -->
        <app-empty-alert-message [show]="!isLoading && items.length === 0" containerClass="m-2"/>

        <app-pagination
                [show]="items.length > 0"
                [itemsAmount]="pagination.itemsAmount"
                [itemsPerPage]="filters.size"
                [currentPage]="currentPage"
                (onChangeItemsPerPage)="changeItemsPerPage($event)"
                (onPaginate)="paginate($event)"/>
    </div>
</div>
